<template>
  <div class="smart-filter">
    <button class="filter-btn" @click="togglePopover">
      <slot name="button">
        <span>Filter</span>
      </slot>
    </button>
    <transition name="fade">
      <div v-if="showPopover" class="popover" @click.self="closePopover">
        <div class="popover-content">
          <div class="popover-header">
            <span class="popover-title">
              <slot name="title">Filters</slot>
            </span>
            <span class="close-icon" @click="closePopover">&times;</span>
          </div>
          <div class="divider"></div>
          <div class="filter-fields">
            <slot />
          </div>
          <div class="divider"></div>
          <div class="actions">
            <button class="apply-btn" @click="apply">Apply</button>
            <button class="reset-btn" @click="reset">Reset</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: "SmartFilter",
  data() {
    return {
      showPopover: false
    };
  },
  methods: {
    togglePopover() {
      this.showPopover = !this.showPopover;
    },
    closePopover() {
      this.showPopover = false;
    },
    apply() {
      this.$emit("apply");
      this.closePopover();
    },
    reset() {
      this.$emit("reset");
      this.closePopover();
    }
  }
};
</script>

<style scoped>
.smart-filter {
  display: inline-block;
  position: relative;
}

.filter-btn {
  background: var(--grad-accent);
  color: var(--surface);
  border: none;
  border-radius: var(--radius-md);
  padding: 0.6rem 1.5rem;
  cursor: pointer;
  font-weight: 600;
  font-size: var(--fs-body);
  box-shadow: var(--shadow-sm);
  transition: box-shadow var(--dur) var(--ease),
    background var(--dur) var(--ease);
}

.filter-btn:hover {
  background: var(--grad-accent-hover);
  box-shadow: var(--shadow-md);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity var(--dur) var(--ease);
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.popover {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(14, 31, 46, 0.35);
  z-index: 1000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
}

.popover-content {
  background: var(--surface);
  margin-top: 7rem;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-md);
  border: 1px solid var(--line);
  padding: 0;
  min-width: 370px;
  max-width: 95vw;
  animation: popin 0.2s var(--ease) 1;
}

@keyframes popin {
  0% {
    transform: scale(0.97);
    opacity: 0;
  }

  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.popover-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.2rem 2rem 0.7rem 2rem;
}

.popover-title {
  font-size: var(--fs-h2);
  font-weight: 600;
  color: var(--ink-900);
}

.close-icon {
  font-size: 1.5rem;
  color: var(--muted);
  cursor: pointer;
  transition: color var(--dur) var(--ease);
}

.close-icon:hover {
  color: var(--danger);
}

.divider {
  height: 1px;
  background: var(--line);
  margin: 0 2rem;
}

.filter-fields {
  padding: 1.2rem 2rem 0.5rem 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.1rem;
}

.actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding: 1.2rem 2rem 1.2rem 2rem;
  background: var(--surface-2);
  border-radius: 0 0 var(--radius-lg) var(--radius-lg);
  border-top: 1px solid var(--line);
}

.apply-btn {
  background: var(--grad-accent);
  color: var(--surface);
  border: none;
  border-radius: var(--radius-sm);
  padding: 0.5rem 1.3rem;
  font-weight: 600;
  font-size: var(--fs-body);
  cursor: pointer;
  transition: background var(--dur) var(--ease);
}

.apply-btn:hover {
  background: var(--grad-accent-hover);
}

.reset-btn {
  background: var(--surface);
  color: var(--text);
  border: 1px solid var(--line);
  border-radius: var(--radius-sm);
  padding: 0.5rem 1.3rem;
  font-weight: 600;
  font-size: var(--fs-body);
  cursor: pointer;
  transition: background var(--dur) var(--ease),
    border-color var(--dur) var(--ease);
}

.reset-btn:hover {
  background: var(--surface-2);
  border-color: var(--line-strong);
}
</style>
